var _g, _mask, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 62,
    viewBox: "0 0 45 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_347_239)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 54.375,
    rx: 7.5,
    ry: 3.75,
    fill: "black",
    fillOpacity: 0.12
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_347_239",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3.75C7.10786 3.75 3.75 7.10786 3.75 11.25V33.75C3.75 37.8921 7.10786 41.25 11.25 41.25H15.6485C18.0914 43.7295 20.3334 46.969 21.0539 51.2241C21.1751 51.9393 21.7746 52.4943 22.5 52.4943C23.2254 52.4943 23.8249 51.9393 23.9461 51.2241C24.6666 46.969 26.9086 43.7295 29.3515 41.25H33.75C37.8921 41.25 41.25 37.8921 41.25 33.75V11.25C41.25 7.10786 37.8921 3.75 33.75 3.75H11.25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3.75C7.10786 3.75 3.75 7.10786 3.75 11.25V33.75C3.75 37.8921 7.10786 41.25 11.25 41.25H15.6485C18.0914 43.7295 20.3334 46.969 21.0539 51.2241C21.1751 51.9393 21.7746 52.4943 22.5 52.4943C23.2254 52.4943 23.8249 51.9393 23.9461 51.2241C24.6666 46.969 26.9086 43.7295 29.3515 41.25H33.75C37.8921 41.25 41.25 37.8921 41.25 33.75V11.25C41.25 7.10786 37.8921 3.75 33.75 3.75H11.25Z",
    fill: "#D15C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6485 41.25L17.0732 39.8464L16.4857 39.25H15.6485V41.25ZM21.0539 51.2241L23.0259 50.8902V50.8902L21.0539 51.2241ZM23.9461 51.2241L21.9741 50.8902V50.8902L23.9461 51.2241ZM29.3515 41.25V39.25H28.5143L27.9268 39.8464L29.3515 41.25ZM5.75 11.25C5.75 8.21243 8.21243 5.75 11.25 5.75V1.75C6.0033 1.75 1.75 6.00329 1.75 11.25H5.75ZM5.75 33.75V11.25H1.75V33.75H5.75ZM11.25 39.25C8.21243 39.25 5.75 36.7876 5.75 33.75H1.75C1.75 38.9967 6.00329 43.25 11.25 43.25V39.25ZM15.6485 39.25H11.25V43.25H15.6485V39.25ZM23.0259 50.8902C22.2147 46.0998 19.6939 42.5063 17.0732 39.8464L14.2238 42.6536C16.4889 44.9527 18.4521 47.8381 19.082 51.558L23.0259 50.8902ZM22.5 50.4943C22.6614 50.4943 22.7965 50.5589 22.8819 50.6351C22.9627 50.7072 23.0101 50.7972 23.0259 50.8902L19.082 51.558C19.3501 53.1409 20.7062 54.4943 22.5 54.4943V50.4943ZM21.9741 50.8902C21.9899 50.7972 22.0373 50.7072 22.1181 50.6351C22.2035 50.5589 22.3386 50.4943 22.5 50.4943V54.4943C24.2938 54.4943 25.6499 53.1409 25.918 51.558L21.9741 50.8902ZM27.9268 39.8464C25.3061 42.5063 22.7853 46.0998 21.9741 50.8902L25.918 51.558C26.5479 47.8381 28.5111 44.9527 30.7762 42.6536L27.9268 39.8464ZM33.75 39.25H29.3515V43.25H33.75V39.25ZM39.25 33.75C39.25 36.7876 36.7876 39.25 33.75 39.25V43.25C38.9967 43.25 43.25 38.9967 43.25 33.75H39.25ZM39.25 11.25V33.75H43.25V11.25H39.25ZM33.75 5.75C36.7876 5.75 39.25 8.21243 39.25 11.25H43.25C43.25 6.0033 38.9967 1.75 33.75 1.75V5.75ZM11.25 5.75H33.75V1.75H11.25V5.75Z",
    fill: "#292828",
    mask: "url(#path-2-inside-1_347_239)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4689 26.3333C18.1305 26.3333 18.6668 25.797 18.6668 25.1354C18.6668 24.4738 18.1305 23.9375 17.4689 23.9375C16.8073 23.9375 16.271 24.4738 16.271 25.1354C16.271 25.797 16.8073 26.3333 17.4689 26.3333Z",
    fill: "#292828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5314 26.3333C28.193 26.3333 28.7293 25.797 28.7293 25.1354C28.7293 24.4738 28.193 23.9375 27.5314 23.9375C26.8698 23.9375 26.3335 24.4738 26.3335 25.1354C26.3335 25.797 26.8698 26.3333 27.5314 26.3333Z",
    fill: "#292828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.354 28.7292C13.5601 28.7292 12.9165 28.0856 12.9165 27.2917V22.8401C12.9165 21.7507 13.5322 20.7549 14.5067 20.2681L14.8334 20.1049L15.9403 15.3566C16.1425 14.4889 16.916 13.875 17.8069 13.875H27.2409C28.1384 13.875 28.9158 14.4979 29.1114 15.3739L30.168 20.1049L30.494 20.2679C31.4679 20.7549 32.0832 21.7503 32.0832 22.8393V27.2917C32.0832 28.0856 31.4396 28.7292 30.6457 28.7292H29.6888V29.2083C29.6888 30.2669 28.83 31.125 27.7714 31.125C26.7129 31.125 25.854 30.2669 25.854 29.2083V28.7292H19.1457V29.2085C19.1457 30.267 18.2876 31.125 17.2291 31.125C16.1707 31.125 15.3126 30.267 15.3126 29.2085V28.7292H14.354Z",
    stroke: "#292828",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7085 21.5415H27.2918L26.5002 17.9794C26.4028 17.541 26.0139 17.229 25.5648 17.229H19.4356C18.9864 17.229 18.5975 17.541 18.5001 17.9794L17.7085 21.5415Z",
    stroke: "#292828",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_347_239",
    x: 11.25,
    y: 46.875,
    width: 22.5,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875,
    result: "effect1_foregroundBlur_347_239"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMarker);
export default __webpack_public_path__ + "static/media/vehicle-marker.6b94d05f0a8f4ba39f3cd94a37c62ffc.svg";
export { ForwardRef as ReactComponent };